<template>
  <div>
    <AllegroAccountHeader
      :accountPk="route.params.pk"
      :accountData="accountData"
      activeTab="offers"
    >
      <div class="row order-filters">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Filtry</h5>
              <div class="ibox-tools"></div>
            </div>
            <div class="ibox-content">
              <div class="col-md-3 offers-filter">
                <div class="form-group">
                  <label>Nr oferty</label>
                  <input
                    v-model="filters.external_id"
                    class="form-control inputClass"
                    type="text"
                    @input="applyFilters"
                  />
                </div>
              </div>
              <div class="col-md-3 offers-filter">
                <div class="form-group">
                  <label>Sygnatura</label>
                  <input
                    v-model="filters.signature"
                    class="form-control inputClass"
                    type="text"
                    @input="applyFilters"
                  />
                </div>
              </div>
              <div class="col-md-3 offers-filter">
                <div class="form-group">
                  <label>Tytuł</label>
                  <input
                    v-model="filters.title"
                    class="form-control inputClass"
                    type="text"
                    @input="applyFilters"
                  />
                </div>
              </div>
              <div class="col-md-3 offers-filter">
                <div class="form-group">
                  <label>Kompletna</label>
                  <select
                    v-model="filters.is_complete"
                    class="form-control inputClass"
                    @change="applyFilters"
                  >
                    <option value="">Wszystkie</option>
                    <option value="true">Tak</option>
                    <option value="false">Nie</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Lista ofert</h5>
        </div>
        <div class="ibox-content">
          <div class="offers-actions">
            <router-link
              v-if="canAddOffer"
              :to="`/allegro/accounts/${route.params.pk}/offer/create`"
              class="btn btn-sm btn-primary"
            >
              <i class="fa fa-plus"></i> Dodaj
            </router-link>
            <button
              v-if="items.length && canChangeOffer"
              type="button"
              class="btn btn-sm btn-primary"
              :disabled="selectedRows.length === 0"
              @click="openModificationModal"
            >
              Zmień czas wysyłki
            </button>
            <button
              v-if="items.length && canChangeOffer"
              type="button"
              class="btn btn-sm btn-primary"
              :disabled="selectedRows.length === 0"
              @click="openPriceChangeModal"
            >
              Zmień cenę
            </button>
          </div>
          <EasyDataTable
            v-model:items-selected="selectedRows"
            :headers="headers"
            :items="items"
            border-cell
            alternating
            show-index
            buttons-pagination
          >
            <template #item-actions="item">
              <router-link
                v-if="canChangeOffer"
                :to="`/allegro/offers/update/${item.pk}`"
              >
                <button class="btn btn-primary btn-xs">
                  <i class="fa fa-edit"></i>
                </button>
              </router-link>
              <button
                v-if="canDeleteOffer"
                @click.stop="openDeleteModal(item)"
                class="btn btn-danger btn-xs"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </AllegroAccountHeader>

    <Modal
      v-if="offerToDelete"
      title="Usuwanie oferty"
      :content="deleteModalContent"
      @callbackOk="deleteOffer"
      @callbackClose="offerToDelete = null"
    />

    <div v-if="mModification" class="modal-dialog">
      <div class="modal-content">
        <div class="inmodal">
          <div class="modal-header">
            <h4 class="modal-title">
              Zmień czas wysyłki wybranych ofert ({{ selectedRows.length }})
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="ibox-content">
                <div
                  v-for="option in deliveryHandlingTimeOpts"
                  :key="option.id"
                  class="radio"
                >
                  <label>
                    <input
                      v-model="selectedDeliveryTime"
                      type="radio"
                      name="deliveryHandlingTime"
                      :value="option.id"
                    />
                    <strong> {{ option.name }}</strong>
                  </label>
                </div>
                <div v-if="!deliveryHandlingTimeOpts.length">
                  Brak dostępnych czasów wysyłki.
                </div>
                <div v-if="modificationError" class="has-error">
                  <span class="help-block">{{ modificationError }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="closeModificationModal" class="btn btn-white">
              Anuluj
            </button>
            <button
              :disabled="!selectedDeliveryTime || isSavingCommand"
              @click="submitModificationCommand"
              class="btn btn-primary"
            >
              {{ isSavingCommand ? "Zapisywanie..." : "Zapisz" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="mModification"
      @click="closeModificationModal"
      class="modal-backdrop"
    ></div>

    <div v-if="mPriceChange" class="modal-dialog">
      <div class="modal-content">
        <div class="inmodal">
          <div class="modal-header">
            <h4 class="modal-title">
              Zmień cenę wybranych ofert ({{ selectedRows.length }})
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="ibox-content">
                <div
                  v-for="option in modifyTypeOpts"
                  :key="option.value"
                  class="m-b"
                >
                  <div class="radio">
                    <label>
                      <input
                        v-model="modificationData.type"
                        type="radio"
                        name="modifyType"
                        :value="option.value"
                        @change="onChangeModifyType"
                      />
                      <strong> {{ option.name }}</strong>
                    </label>
                  </div>

                  <div v-if="option.value === ownPriceOpt" class="form-group">
                    <label class="control-label col-sm-3">Cena</label>
                    <div class="col-sm-9">
                      <input
                        v-model="modificationData.price"
                        :disabled="!isOwnPriceSelected"
                        type="number"
                        step="0.01"
                        class="form-control inputClass"
                      />
                    </div>
                  </div>

                  <div v-if="option.value === modifyOwnPriceOpt">
                    <div class="form-group">
                      <label class="control-label col-sm-3">Operacja</label>
                      <div class="col-sm-9">
                        <select
                          v-model="modificationData.operation"
                          :disabled="!isModifyOwnPriceSelected"
                          class="form-control inputClass"
                        >
                          <option
                            v-for="operation in operationOpts"
                            :key="operation.value"
                            :value="operation.value"
                          >
                            {{ operation.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-3">Modyfikator</label>
                      <div class="col-sm-9">
                        <select
                          v-model="modificationData.modificator"
                          :disabled="!isModifyOwnPriceSelected"
                          class="form-control inputClass"
                          @change="onChangeModificator"
                        >
                          <option
                            v-for="modificator in modificatorOpts"
                            :key="modificator.value"
                            :value="modificator.value"
                          >
                            {{ modificator.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-if="isPriceModificator" class="form-group">
                      <label class="control-label col-sm-3">Kwota (zł)</label>
                      <div class="col-sm-9">
                        <input
                          v-model="modificationData.value"
                          :disabled="!isModifyOwnPriceSelected"
                          type="number"
                          step="0.01"
                          class="form-control inputClass"
                        />
                      </div>
                    </div>
                    <div v-if="isPercentageModificator" class="form-group">
                      <label class="control-label col-sm-3">Procent (%)</label>
                      <div class="col-sm-9">
                        <input
                          v-model="modificationData.percentage"
                          :disabled="!isModifyOwnPriceSelected"
                          type="number"
                          step="0.01"
                          class="form-control inputClass"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="priceChangeError" class="has-error">
                  <span class="help-block">{{ priceChangeError }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="closePriceChangeModal" class="btn btn-white">
              Anuluj
            </button>
            <button
              :disabled="isSavingCommand"
              @click="submitPriceChangeCommand"
              class="btn btn-primary"
            >
              {{ isSavingCommand ? "Zapisywanie..." : "Zapisz" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="mPriceChange"
      @click="closePriceChangeModal"
      class="modal-backdrop"
    ></div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import AllegroAccountHeader from "./AllegroAccountHeader.vue";
import Modal from "../caffeprint/Modal.vue";
import { hasPermission } from "../../permissions";
import {
  allegroOfferPermissionsConst,
  allegroOfferMessagesConst,
  allegroOfferCmdConst,
  allegroOfferCmdTypeConst,
  allegroOfferCmdMessageConst,
} from "../../constants/allegroConstants";

export default {
  name: "AllegroAccountOffers",
  components: { AllegroAccountHeader, Modal },
  setup() {
    const route = useRoute();
    const store = useStore();

    // --- Current admin permissions ---
    const canAddOffer = computed(() =>
      hasPermission(allegroOfferPermissionsConst.add)
    );
    const canChangeOffer = computed(() =>
      hasPermission(allegroOfferPermissionsConst.update)
    );
    const canDeleteOffer = computed(() =>
      hasPermission(allegroOfferPermissionsConst.delete)
    );
    // --- End: current admin permissions ---
    const accountData = ref({});
    const items = ref([]);
    const filters = ref({
      external_id: "",
      signature: "",
      title: "",
      is_complete: "",
    });
    const selectedRows = ref([]);
    const headers = [
      { text: "ID Produktu", value: "product" },
      { text: "Sygnatura", value: "signature" },
      { text: "Numer oferty", value: "external_id" },
      { text: "Tytuł", value: "title" },
      { text: "Cena", value: "price" },
      { text: "Czas wysyłki", value: "delivery_handling_time_display" },
      { text: "Status publikacji", value: "publication_status_display" },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified" },
      { text: "Edytowano przez", value: "last_modified_by" },
      { text: "Akcje", value: "actions" },
    ];
    const offersRaw = computed(() => store.getters.getAllegroAccountOffersData);
    const accountRaw = computed(() => store.getters.getAllegroAccountData);
    const applyFilters = () => {
      selectedRows.value = [];
      getOffers();
    };

    const selectedOfferPks = () => selectedRows.value.map((row) => row.pk);

    // --- Offer removal ---
    const offerToDelete = ref(null);
    const deleteAllOfferData = computed(
      () => store.getters.getDeleteAllOfferData
    );

    const deleteModalContent = computed(() => {
      const offer = offerToDelete.value;
      if (!offer) {
        return "";
      }
      const label = offer.external_id
        ? `o numerze: <b>${offer.external_id}</b>`
        : `o ID: <b>${offer.pk}</b>`;
      return `Czy na pewno chcesz usunąć ofertę ${label} ?`;
    });

    const openDeleteModal = (item) => {
      if (!canDeleteOffer.value) {
        return;
      }
      offerToDelete.value = item;
    };

    const deleteOffer = () => {
      if (!canDeleteOffer.value) {
        return;
      }
      store.dispatch("deleteAllOffer", offerToDelete.value.pk);
    };
    // --- End: offer removal ---

    // --- Offer commands (delivery handling time / price) ---
    const mModification = ref(false);
    const mPriceChange = ref(false);
    const isSavingCommand = ref(false);
    const modificationError = ref(null);
    const priceChangeError = ref(null);
    const deliveryHandlingTimeOpts = ref([]);
    const selectedDeliveryTime = ref(null);
    const modificationData = ref({
      type: allegroOfferCmdConst.ownPriceOpt,
      operation: allegroOfferCmdConst.additionOperationOpt,
      modificator: allegroOfferCmdConst.priceModificatorOpt,
      price: null,
      value: null,
      percentage: null,
    });

    const deliveryTimesRaw = computed(
      () => store.getters.getAllDeliveryTimesData
    );

    const isOwnPriceSelected = computed(
      () => modificationData.value.type === allegroOfferCmdConst.ownPriceOpt
    );
    const isModifyOwnPriceSelected = computed(
      () =>
        modificationData.value.type === allegroOfferCmdConst.modifyOwnPriceOpt
    );
    const isPriceModificator = computed(
      () =>
        modificationData.value.modificator ===
        allegroOfferCmdConst.priceModificatorOpt
    );
    const isPercentageModificator = computed(
      () =>
        modificationData.value.modificator ===
        allegroOfferCmdConst.percentageModificatorOpt
    );

    const onChangeModifyType = () => {
      if (isModifyOwnPriceSelected.value) {
        modificationData.value.price = null;
      }
      if (isOwnPriceSelected.value) {
        modificationData.value.value = null;
        modificationData.value.percentage = null;
      }
    };

    const onChangeModificator = () => {
      if (isPercentageModificator.value) {
        modificationData.value.value = null;
      }
      if (isPriceModificator.value) {
        modificationData.value.percentage = null;
      }
    };

    const getCommandErrorMessage = (error, fallback) => {
      const data = error?.response?.data;
      if (!data) {
        return fallback;
      }
      if (Array.isArray(data.nonFieldErrors)) {
        return data.nonFieldErrors[0];
      }
      if (Array.isArray(data.non_field_errors)) {
        return data.non_field_errors[0];
      }
      const entries = Object.entries(data);
      if (!entries.length) {
        return fallback;
      }
      const [key, value] = entries[0];
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const [nestedKey, nestedValue] = Object.entries(value)[0] || [];
        return nestedKey
          ? `${nestedKey}: ${
              Array.isArray(nestedValue) ? nestedValue[0] : nestedValue
            }`
          : fallback;
      }
      return `${key}: ${Array.isArray(value) ? value[0] : value}`;
    };

    const openModificationModal = () => {
      if (!canChangeOffer.value) {
        return;
      }
      modificationError.value = null;
      selectedDeliveryTime.value = null;
      store.dispatch("getAllDeliveryTimes", { accountPk: route.params.pk });
      mModification.value = true;
    };

    const closeModificationModal = () => {
      mModification.value = false;
    };

    const submitModificationCommand = () => {
      if (!canChangeOffer.value) {
        return;
      }
      isSavingCommand.value = true;
      modificationError.value = null;

      store
        .dispatch("createAllegroOfferModificationCommand", {
          offers: selectedOfferPks(),
          type: allegroOfferCmdTypeConst.deliveryHandlingTimeModification,
          modification: {
            delivery_handling_time: selectedDeliveryTime.value,
          },
        })
        .then(() => {
          store.dispatch("showToaster", {
            type: "success",
            content: allegroOfferCmdMessageConst.changeDeliveryTime,
          });
          closeModificationModal();
          selectedRows.value = [];
          getOffers();
        })
        .catch((error) => {
          modificationError.value = getCommandErrorMessage(
            error,
            "Nie udało się zmienić czasu wysyłki."
          );
          store.dispatch("showToaster", {
            type: "error",
            content: modificationError.value,
          });
        })
        .finally(() => {
          isSavingCommand.value = false;
        });
    };

    const openPriceChangeModal = () => {
      if (!canChangeOffer.value) {
        return;
      }
      priceChangeError.value = null;
      modificationData.value = {
        type: allegroOfferCmdConst.ownPriceOpt,
        operation: allegroOfferCmdConst.additionOperationOpt,
        modificator: allegroOfferCmdConst.priceModificatorOpt,
        price: null,
        value: null,
        percentage: null,
      };
      mPriceChange.value = true;
    };

    const closePriceChangeModal = () => {
      mPriceChange.value = false;
    };

    // Only the fields relevant for the chosen modification type are sent -
    // the backend rejects the rest.
    const getPriceModificationPayload = () => {
      if (isOwnPriceSelected.value) {
        return {
          type: modificationData.value.type,
          price: modificationData.value.price,
        };
      }

      const payload = {
        type: modificationData.value.type,
        operation: modificationData.value.operation,
        modificator: modificationData.value.modificator,
      };

      if (isPriceModificator.value) {
        payload.value = modificationData.value.value;
      } else {
        payload.percentage = modificationData.value.percentage;
      }

      return payload;
    };

    const submitPriceChangeCommand = () => {
      if (!canChangeOffer.value) {
        return;
      }
      isSavingCommand.value = true;
      priceChangeError.value = null;

      store
        .dispatch("createAllegroOfferPriceChangeCommand", {
          offers: selectedOfferPks(),
          type: allegroOfferCmdTypeConst.priceModification,
          modification: getPriceModificationPayload(),
        })
        .then(() => {
          store.dispatch("showToaster", {
            type: "success",
            content: allegroOfferCmdMessageConst.changePrice,
          });
          closePriceChangeModal();
          selectedRows.value = [];
          getOffers();
        })
        .catch((error) => {
          priceChangeError.value = getCommandErrorMessage(
            error,
            "Nie udało się zmienić ceny."
          );
          store.dispatch("showToaster", {
            type: "error",
            content: priceChangeError.value,
          });
        })
        .finally(() => {
          isSavingCommand.value = false;
        });
    };
    // --- End: offer commands ---

    const getOffers = () => {
      store.dispatch("getAllegroAccountOffers", {
        accountPk: route.params.pk,
        search: filters.value,
      });
    };

    store.dispatch("getAllegroAccount", route.params.pk);
    getOffers();
    watch(
      () => offersRaw.value,
      (newValue) => {
        const data = newValue?.data;
        items.value = data?.results ? data.results : data || [];
      },
      { deep: true }
    );
    watch(
      () => accountRaw.value,
      (newValue) => {
        accountData.value = newValue?.data || {};
      },
      { deep: true }
    );
    watch(
      () => deleteAllOfferData.value,
      (newValue) => {
        if (newValue?.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: allegroOfferMessagesConst.delete,
          });
          offerToDelete.value = null;
          selectedRows.value = [];
          getOffers();
          return;
        }

        // A failed removal used to leave the modal open without a word
        offerToDelete.value = null;
        store.dispatch("showToaster", {
          type: "error",
          content: newValue?.data?.detail || allegroOfferMessagesConst.error,
        });
      }
    );
    watch(
      () => deliveryTimesRaw.value,
      (newValue) => {
        deliveryHandlingTimeOpts.value = Array.isArray(newValue?.data)
          ? newValue.data
          : [];
      },
      { deep: true }
    );

    return {
      route,
      headers,
      items,
      accountData,
      filters,
      selectedRows,
      applyFilters,
      canAddOffer,
      canChangeOffer,
      canDeleteOffer,
      // Offer removal
      offerToDelete,
      deleteModalContent,
      openDeleteModal,
      deleteOffer,
      // Offer commands
      mModification,
      mPriceChange,
      isSavingCommand,
      modificationError,
      priceChangeError,
      deliveryHandlingTimeOpts,
      selectedDeliveryTime,
      modificationData,
      modifyTypeOpts: allegroOfferCmdConst.modifyTypeOpts,
      operationOpts: allegroOfferCmdConst.operationOpts,
      modificatorOpts: allegroOfferCmdConst.modificatorOpts,
      ownPriceOpt: allegroOfferCmdConst.ownPriceOpt,
      modifyOwnPriceOpt: allegroOfferCmdConst.modifyOwnPriceOpt,
      isOwnPriceSelected,
      isModifyOwnPriceSelected,
      isPriceModificator,
      isPercentageModificator,
      onChangeModifyType,
      onChangeModificator,
      openModificationModal,
      closeModificationModal,
      submitModificationCommand,
      openPriceChangeModal,
      closePriceChangeModal,
      submitPriceChangeCommand,
    };
  },
};
</script>

<style scoped>
/* Offer list actions aligned to the left, above the table */
.offers-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
}

/* Spacing between the offer filter fields */
.offers-filter {
  padding-left: 0;
  padding-right: 15px;
}

.offers-filter:last-child {
  padding-right: 0;
}

.offers-filter .form-group {
  margin-bottom: 10px;
}
</style>
